import PropTypes from 'prop-types';

const accountProgramNameShape = PropTypes.oneOf(['ABLE', 'STABLE', 'True Link']);

export const accountProgramTypeShape = PropTypes.oneOf(['able', 'stable', 'en']);

export default accountProgramNameShape;
